import type { NikolaGameReference } from "@chessla/shared";

export const gameReviewUrl = (
  reference: Pick<NikolaGameReference, "gameId" | "factId" | "ply" | "moveNumber" | "san">,
): string => {
  const query = new URLSearchParams();
  if (reference.factId) query.set("moment", reference.factId);
  if (reference.ply) query.set("ply", String(reference.ply));
  const move = reference.moveNumber ?? (reference.ply ? Math.ceil(reference.ply / 2) : undefined);
  if (move && reference.san) {
    query.set("move", String(move));
    query.set("san", reference.san);
  }
  const suffix = query.toString();
  return `/games/${encodeURIComponent(reference.gameId)}${suffix ? `?${suffix}` : ""}`;
};
